export default "__VITE_ASSET__DzJYTEfI__"